import ReactDOM from 'react-dom/client';
import './index.css';
import { MsalProvider } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';
import { generateMsalConfig } from './features/authentication';
import App from './App';

const thumbStyles = `
.radio-container {
  display: flex;
  align-items: center;
}

.radio-label {
  margin-left: 0.8vh;
  font-size: 1.4vh;
  font-weight: 400;
  color: rgba(16, 29, 59, 1);
}

.radio-input {
  appearance: none;
  width: 2.4vh;
  height: 2.4vh;
  border: 0.1vh solid rgba(16, 29, 59, 0.2);
  border-radius: 50%;
  position: relative;
  outline: none;
  cursor: pointer;
  margin: 0vh;
}

.radio-input:checked {
  border: 0.2vh solid rgba(0, 171, 155, 1);
}

.radio-input:checked::before {
  content: '';
  width: 1.6vh;
  height: 1.6vh;
  background-color: rgba(0, 171, 155, 1);
  border-radius: 50%;
  position: absolute;
  top: 0.2vh;
  left: 0.2vh;
}
`;

const msalInstanceProvider = new PublicClientApplication(generateMsalConfig());

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <MsalProvider instance={msalInstanceProvider}>
    <style>{thumbStyles}</style>
    <App />
  </MsalProvider>
);
